import { accessSuspendedVar, authState, unpaidInvoicesModalOpenVar } from 'core/state';
import { client } from 'core/graphql/client';
import { removeToken } from 'services/AuthService';
import { clearUnpaidInvoicesModalFlags } from 'core/hooks/Invoices/unpaidInvoicesModalSession';

export const logout = () => {
  client.clearStore();
  removeToken();
  // ТЗ 0074: «раз за вход» — следующий вход снова покажет поп-ап фактур.
  // Флаг опросного поп-апа (ТЗ 0011) не трогаем: он задуман «раз за сессию»,
  // и стирать его при выходе значило бы поменять его поведение.
  clearUnpaidInvoicesModalFlags();
  unpaidInvoicesModalOpenVar(false);
  accessSuspendedVar(false);
  authState({
    isLoggedIn: false,
    access_token: null,
    refresh_token: null,
    isTokenRefreshed: false,
    active_role: null,
    isDemoUser: false,
  });
};
